import confirm from 'components/confirm';

export async function DirtyShadowConfirmationPrompt(message, callback, selectShadow, setDirty) {
  try {
    await confirm(message, {
      buttonLabel: 'Leave',
      buttonStyle: 'danger',
      title: 'Unsaved Changes',
    });
    selectShadow(null);
    setDirty(false);
    callback(true);
  } catch (error) {
    // Confirmation canceled
  }
}

export default DirtyShadowConfirmationPrompt;
